import React from "react";
import { useTranslation } from "react-i18next";
import FormatDate, {
	FormatTime,
	defaultMinuteFormatTime,
	exactlySameDay,
} from "go-core/components/Formatters/FormatDate";
import { ReactComponent as CircleInfoSVG } from "go-core/images/svg/circle-info.svg";
import { DeliveryEstimationApi } from "../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	deliveryEstimation: DeliveryEstimationApi;
	ownDriver?: boolean;
}

const LiveOrderModalEstimatedTimeInfo = ({ deliveryEstimation, ownDriver }: Props) => {
	const { t } = useTranslation();
	const deliveryPickUpDate = new Date(
		new Date().getTime() + deliveryEstimation.delivery_pickup_in_minutes * 60 * 1000
	);
	const totalDeliveryPickUpDate = new Date(
		new Date().getTime() +
			(deliveryEstimation.delivery_pickup_in_minutes + deliveryEstimation.pickup_in_minutes) * 60 * 1000
	);

	return (
		<div className="d-flex gap-2 live-order-delivery-estimation-time-info">
			<CircleInfoSVG />
			<span>
				{ownDriver
					? t("modules.live_order.field.estimated_order_time", {
							time: deliveryEstimation.delivery_pickup_in_minutes + deliveryEstimation.pickup_in_minutes,
							date: exactlySameDay(new Date(), totalDeliveryPickUpDate)
								? FormatTime(totalDeliveryPickUpDate, undefined, defaultMinuteFormatTime)
								: FormatDate(totalDeliveryPickUpDate),
					  })
					: t("modules.live_order.field.delivery_estimated_time", {
							time: deliveryEstimation.delivery_pickup_in_minutes,
							date: exactlySameDay(new Date(), deliveryPickUpDate)
								? FormatTime(deliveryPickUpDate, undefined, defaultMinuteFormatTime)
								: FormatDate(deliveryPickUpDate),

							totalTime:
								deliveryEstimation.delivery_pickup_in_minutes + deliveryEstimation.pickup_in_minutes,

							totalDate: exactlySameDay(new Date(), totalDeliveryPickUpDate)
								? FormatTime(totalDeliveryPickUpDate, undefined, defaultMinuteFormatTime)
								: FormatDate(totalDeliveryPickUpDate),
					  })}
			</span>
		</div>
	);
};

export default LiveOrderModalEstimatedTimeInfo;
